import subscriptionUnavailableDictionary from '@pages/subscription-unavailable/i18n/ru/subscription-unavailable.dic.json';

import terminateContractDictionary from '@widgets/terminate-contract/i18n/ru/terminate-contract.dic.json';

export const terminateContract = {
  TERMINATE_CONTRACT: terminateContractDictionary,
  SUBSCRIPTION_UNAVAILABLE: subscriptionUnavailableDictionary,
};

export const terminateContractNamespaces = Object.keys(terminateContract);
